<template lang='pug'>
v-card(light)
    template(v-if='noRequestFound')
        v-card-text
            v-row
                v-col
                    p No request was found. Please try again. If the error persists, contact Engineering.
        v-card-actions
            v-spacer
            v-btn(@click='close', text) Close
    template(v-else)
        v-card-title {{subscription?.type}} Activation Request
        v-card-text
            v-row
                v-col
                    p {{customer?.name}} requested access to {{subscription?.type}} on {{formatDate(createdAt)}}. The following contact information was provided:
                    span Name: {{subscription?.name}}
                    br
                    span Phone: {{subscription?.phoneNumber}}
                    br
                    span Email: {{subscription?.email}}
                    template(v-if='type==="SCADAsure"')
                        br
                        span Distribution Email: {{subscription?.distributionEmail}}
            v-row
                v-col
                    p The request was made by {{customersUser?.firstName}} {{customersUser?.lastName}} through the customer portal.
            template(v-if='closed')
                v-row
                    v-col
                        p(v-if='completed') The request by marked as "Complete" by {{user?.firstName}} {{user?.lastName}} on {{formatDate(closedDate)}}.
                        p(v-else) The request was closed by {{user?.firstName}} {{user?.lastName}} on {{formatDate(closedDate)}}.
                v-row
                    v-col
                        v-btn.white--text(small, color='brand', @click='reopenRequest') Reopen Request
        v-card-actions
            v-spacer
            v-btn(@click='close', text) Close
            v-btn(@click='markAsClosed', color='warning', small, :disabled='closed') Mark as closed
            v-btn(@click='markAsComplete', color='success', small, :disabled='closed') Mark as complete
    v-snackbar(v-model='showSnackbar', :timeout='5000') {{snackbarText}}
        template(v-slot:action='{attrs}')
            v-btn(text, @click='reopenRequest') Undo

</template>
<script>
export default {
    props: {
        id: {
            type: String,
            default () {
                return '';
            }
        }
    },
    data () {
        return {
            accessKey: 'customersrequests',
            snackbarText: '',
            showSnackbar: false,
            noRequestFound: false,


            closed: false,
            closedBy: 0,
            closedDate: '',
            completed: false,
            createdAt: '',
            customer: null,
            customersUser: '', // requested by person
            type: '',
            user: null,

            subscription: {
                id: 0,
                createdAt: '',
                name: '',
                type: '',
                phoneNumber: '',
                email: '',
                distributionEmail: '',
                user: null,
            }

        };
    },
    methods: {
        async getData () {
            const numericId = Number.parseInt(this.id);
            if (Number.isNaN(numericId)) this.id = 0;
            this.noRequestFound = false;
            const req = await this.sendCommand({
                action: 'getRequestDetails',
                parameters: {
                    id: numericId
                }
            });
            if (req) {
                // the request subtype (add more types later)
                this.subscription = req.customersSubscriptionRequest;

                this.closed = req.closed;
                this.closedBy = req.closedBy;
                this.closedDate = req.closedDate;
                this.completed = req.completed;
                this.createdAt = req.createdAt;
                this.customer = req.customer;
                this.customersUser = req.customersUser;
                this.type = req.type;
                this.user = req.user;
            } else {
                this.noRequestFound = true;
                this.subscription = { id: 0, createdAt: '', name: '', type: '', phoneNumber: '', email: '', distributionEmail: '', user: null };
                this.closed = false;
                this.closedBy = 0;
                this.closedDate = '';
                this.completed = false;
                this.createdAt = '';
                this.customer = null;
                this.customersUser = '';
                this.type = '';
                this.user = null;
            }
        },
        close () {
            this.$emit('close');
        },
        formatDate (date) {
            if (!date) {
                return '';
            }
            date = new Date(date);
            return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
        },
        async markAsClosed () {
            const response = await this.sendCommand({
                action: 'closeRequest',
                parameters: {
                    requestId: this.id,
                    email: this.$store.state.dorsettUser.email
                }
            });

            if (response.success) {
                this.snackbarText = 'Request has been closed!';
                this.showSnackbar = true;
            }
            this.refreshData();
        },
        async markAsComplete () {
            const response = await this.sendCommand({
                action: 'markRequestAsComplete',
                parameters: {
                    requestId: this.id,
                    email: this.$store.state.dorsettUser.email
                }
            });
            if (response.success) {
                this.snackbarText = 'Request has been completed!';
                this.showSnackbar = true;
            }
            this.refreshData();
        },
        async reopenRequest () {
            const response = await this.sendCommand({
                action: 'reopenRequest',
                parameters: {
                    requestId: this.id,
                    email: this.$store.state.dorsettUser.email
                }
            });
            if (response.success) {
                this.snackbarText = 'Request has been reopened';
                this.showSnackbar = true;
            }
            this.refreshData();
        },
        async refreshData () {
            await this.getData();
            this.$emit('refresh');
        }
    },
    watch: {
        id: {
            handler (id) {
                this.getData();
            },
            immediate: true
        }
    }
};
</script>
